import { Pages } from "src/auth/types";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { DeepReadonly } from "./utils";

export function isOnlySSO(methods: readonly OrgConfig.LoginMethod[]): boolean {
  if (methods.length > 1) {
    return false;
  }

  if (methods.find((m) => m.method === "sso") !== undefined) {
    return true;
  }

  return false;
}

export function isEmailPasswordEnabled(
  methods: readonly DeepReadonly<OrgConfig.LoginMethod>[]
): boolean {
  return methods.find((m) => m.method === "email") !== undefined;
}

export function isSMSEnabled(methods: OrgConfig.LoginMethod[]): boolean {
  return methods.find((m) => m.method === "sms") !== undefined;
}

export type ParentAuthMethod = "email" | "phone";

export type ParentLoginConfig = {
  parent: readonly { method: string }[];
  parentDefaultMethod?: "sso" | "email" | "sms";
};

export function resolveParentAuthMethod(
  config: ParentLoginConfig,
  explicitMethod?: string | null
): ParentAuthMethod {
  const emailEnabled = config.parent.some((entry) => entry.method === "email");
  const smsEnabled = config.parent.some((entry) => entry.method === "sms");

  if (explicitMethod === "email" && emailEnabled) {
    return "email";
  }
  if (explicitMethod === "phone" && smsEnabled) {
    return "phone";
  }
  if (smsEnabled && (!emailEnabled || config.parentDefaultMethod === "sms")) {
    return "phone";
  }
  return "email";
}

export function getSSOsForPage(
  page: Pages,
  methods: OrgConfig.LoginMethod[]
): OrgConfig.SSOLogin[] {
  if (page !== Pages.Login) {
    return [];
  }

  return methods.filter((m): m is OrgConfig.SSOLogin => {
    return m.method === "sso";
  });
}
